import Moment from 'moment';

export const dateSlashFormat = 'DD/MM/YYYY';
export const dateHyphenFormat = 'YYYY-MM-DD';
export const dateDotFormat = 'D.M.YYYY';

/* Evaluated per call, not at module load, so a long lived tab never serves a stale "today". */
export const getNextMonth = () => Moment().add(1, 'month').startOf('month');
export const getNextMonthHyphen = () => getNextMonth().format(dateHyphenFormat);

export const getNextMonthsEnd = () => Moment().add(1, 'month').endOf('month').toDate();

export const getTodayHyphen = () => Moment().format(dateHyphenFormat);

export const reformatSlashDateToHyphen = date => Moment(date, dateSlashFormat).format(dateHyphenFormat);

export const getDaysSinceMonthStart = date => Moment(date).diff(Moment(date).startOf('month'), 'days');

export const getDaysToMonthEnd = date => Moment(date).endOf('month').diff(Moment(date), 'days');

export const getDaysInMonth = date => Moment(date).endOf('month').format('DD');

export const getDayFromDate = date => Moment(date).format('DD');

export const getPolicyEndDate = date => Moment(date)
  .add(1, 'year')
  .subtract(1, 'month')
  .endOf('month')
  .format(dateSlashFormat);
